import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "../services/auth.service";
import { SharedDataService } from "../services/shared.service";
import { SidebarService } from "../services/sidebar.service";
import { environment } from "src/environments/environment";

declare var $: any;
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  public sidebarCollapsed = false;
  public videoWall = true;
  public sideMenus: any[] = [];
  public tenantId: any;
  public getLogo: string;

  constructor(
    private _AuthService: AuthService,
    private _SidebarService: SidebarService,
    public _SharedService: SharedDataService,
    private toastr: ToastrService,
    private router: Router,
    private SharedDataService: SharedDataService,
  ) {}

  ngOnInit(): void {
    this.navbarLogoUpdate();

    if (this._AuthService.getUserName().tenantName == "comcraft") {
      this.videoWall = false;
    }
  }
  @Output() sidebarCollapse = new EventEmitter();
  sidebarCollapseToggle() {
    //
    this.sidebarCollapsed = !this.sidebarCollapsed;
    this.sidebarCollapse.emit({ sidebarCollapsed: this.sidebarCollapsed });
  }
  mouseEnter(id) {
    $("#" + id).addClass("hover-open");
  }
  mouseLeave(id) {
    $("#" + id).removeClass("hover-open");
  }
  selectMenu(id) {
    let item: any;
    this._SharedService.sideMenusList.forEach((menu) => {
      if (menu["module"]["id"] == id) {
        item = menu["module"];
      }
    });
    // let item = this._SharedService.sideMenusList['module'][id];
    console.log(id);
    // if (id != 8) {
    if (item["pageUrl"] != null) {
      $("#" + id).removeClass("hover-open");
      $("#ui-" + id).removeClass("show");
      $(".nav-link").attr("aria-expanded", "false");
    }
  }
  Logout() {
    // localStorage.removeItem("token");
    localStorage.removeItem(environment.ProjectName + "-token");
    this.SharedDataService.sideMenusList = [];
    this.SharedDataService.sidebarURLs = [];
    this.SharedDataService.isSidebarLoaded = false;
    this.router.navigate(["/sso/login"]);
  }
  navbarLogoUpdate() {
    let decodeToken = JSON.parse(
      atob(
        localStorage.getItem(environment.ProjectName + "-token").split(".")[1],
      ),
    );

    this.tenantId = decodeToken.tenantId;
    this.getLogo =
      environment.IDENTITY + "/cdn/tenants/logo/" + this.tenantId + ".png";
  }
}
